"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContrastingTextColorHexString = exports.getContrastingTextColorHex8String = exports.default = exports.PRIMARY_CONTRAST_STANDARD = void 0;
var _tinycolor = require("@ctrl/tinycolor");
var _sharedThemeSettings = require("../themes/sharedThemeSettings");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var PRIMARY_CONTRAST_STANDARD = exports.PRIMARY_CONTRAST_STANDARD = 8;
var getContrastingTextColor = function getContrastingTextColor(backgroundColor) {
  var textOnDark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _sharedThemeSettings.colors.textOnDark;
  var textOnLight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _sharedThemeSettings.colors.textOnLight;
  var threshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var darkReadability = (0, _tinycolor.readability)(textOnDark, backgroundColor);
  var lightReadability = (0, _tinycolor.readability)(textOnLight, backgroundColor);
  return darkReadability + threshold > lightReadability ? textOnDark : textOnLight;
};
var getContrastingTextColorHex8String = exports.getContrastingTextColorHex8String = function getContrastingTextColorHex8String() {
  return new _tinycolor.TinyColor(getContrastingTextColor.apply(void 0, arguments)).toHex8String();
};
var getContrastingTextColorHexString = exports.getContrastingTextColorHexString = function getContrastingTextColorHexString() {
  return new _tinycolor.TinyColor(getContrastingTextColor.apply(void 0, arguments)).toHexString();
};
var _default = exports.default = getContrastingTextColor;